/*
 * 字典域接口：下拉数据 / 树形字典 / 标签翻译
 *
 * @Author: Mustafa.Yin
 * @Date: 2026-10-31
 */
import { get } from '@/utils/request';
import logger from '@/utils/logger';

/**
 * 按字典类型+宠物类型查字典（varieties_pet/disease_type/susceptibility/life_stage/amount_of_exercise/criteria_type 等）
 * @returns {Promise<Array>} 字典列表
 */
export function getDictByTypeAndPet(dictType, petType) {
  // 后端 petType 为必填参数：无值时不发起请求（避免 500），返回 undefined 由调用方判空跳过
  if (petType === undefined || petType === null || petType === '') {
    logger.warn('dict', 'petType 为空，跳过字典查询 ' + dictType);
    return Promise.resolve(undefined);
  }
  return get('smartreco/api/getDictByTypeAndPet', { dictType, petType }, { apiName: 'dict' });
}

/**
 * 树形字典（疾病/易感性的层级选择）
 * @returns {Promise<Array>} 树形字典
 */
export function queryTreeDict(dictType, petType) {
  return get('smartreco/api/queryTreeDict', { dictType, petType }, { apiName: 'treeDict' });
}

/**
 * 单标签翻译（如 varieties_pet 的品种名）
 * @returns {Promise<string>} 字典标签
 */
export function getDictLabelByType(dictType, dictValue) {
  return get('smartreco/api/getDictLabelByType', { dictType, dictValue }, { apiName: 'dictLabel' });
}
